

// import React, { useState } from 'react';
// import mechImg from "../Component/vr-picture1.jpg";

// // Sample card data
// const cardData = {
//   section1: {
//     Mechanical: [...Array(6)].map((_, i) => ({ title: `Mech Card ${i + 1}`, img: mechImg, link: `/mech${i + 1}` })),
//     IT: [...Array(6)].map((_, i) => ({ title: `IT Card ${i + 1}`, img: mechImg, link: `/it${i + 1}` })),
//     'Digital Factory': [...Array(6)].map((_, i) => ({ title: `DF Card ${i + 1}`, img: mechImg, link: `/df${i + 1}` }))
//   },
//   section2: [...Array(6)].map((_, i) => ({ title: `Sec2 Card ${i + 1}`, img: mechImg, link: `/sec2-${i + 1}` })),
//   section3: [...Array(4)].map((_, i) => ({ title: `Sec3 Card ${String.fromCharCode(65 + i)}`, img: mechImg, link: `/sec3-${i}` })),
//   section4: [...Array(4)].map((_, i) => ({ title: `Sec4 Card ${String.fromCharCode(88 + i)}`, img: mechImg, link: `/sec4-${i}` }))
// };

// const MultiSectionFilter = () => {
//   const [activeSection, setActiveSection] = useState(1);
//   const [selectedBranch, setSelectedBranch] = useState('Mechanical');
//   const [dateFilter, setDateFilter] = useState('');
//   const [calendarDate, setCalendarDate] = useState('');
//   const [location, setLocation] = useState('');
//   const [language, setLanguage] = useState('');
//   const [price, setPrice] = useState('');

//   const getCardsForSection = () => {
//     if (activeSection === 1) return cardData.section1[selectedBranch];
//     if (activeSection === 2) return cardData.section2;
//     if (activeSection === 3) return cardData.section3;
//     if (activeSection === 4) return cardData.section4;
//     return [];
//   };

//   return (
//     <div style={outerContainerStyle}>
//       {/* Top Fixed Button Bar */}
//       <div style={topBarStyle}>
//         {['Section 1', 'Section 2', 'Section 3', 'Section 4'].map((label, index) => (
//           <button key={index} onClick={() => setActiveSection(index + 1)} style={topBtnStyle}>
//             {label}
//           </button>
//         ))}
//       </div>

//       {/* Main Content Area with Sidebar + Cards */}
//       <div style={mainContentStyle}>
//         {/* Sidebar */}
//         <div style={sidebarStyle}>
//           <div style={filterGroupStyle}>
//             <label>Branches</label>
//             <select value={selectedBranch} onChange={(e) => setSelectedBranch(e.target.value)} style={dropdownStyle}>
//               <option value="Mechanical">Mechanical</option>
//               <option value="IT">IT</option>
//               <option value="Digital Factory">Digital Factory</option>
//             </select>
//           </div>

//           <div style={filterGroupStyle}>
//             <label>Date</label>
//             <select value={dateFilter} onChange={(e) => setDateFilter(e.target.value)} style={dropdownStyle}>
//               <option value="">Date</option>
//               <option value="today">Today</option>
//               <option value="tomorrow">Tomorrow</option>
//               <option value="weekend">This Weekend</option>
//             </select>
//             <input
//               type="date"
//               value={calendarDate}
//               onChange={(e) => setCalendarDate(e.target.value)}
//               style={{ ...dropdownStyle, marginTop: '8px' }}
//             />
//           </div>

//           <div style={filterGroupStyle}>
//             <label>Location</label>
//             <select value={location} onChange={(e) => setLocation(e.target.value)} style={dropdownStyle}>
//               <option value="">Location</option>
//               <option value="hyderabad">Hyderabad</option>
//               <option value="bangalore">Bangalore</option>
//               <option value="chennai">Chennai</option>
//               <option value="mumbai">Mumbai</option>
//             </select>
//           </div>

//           <div style={filterGroupStyle}>
//             <label>Language</label>
//             <select value={language} onChange={(e) => setLanguage(e.target.value)} style={dropdownStyle}>
//               <option value="">Language</option>
//               <option value="english">English</option>
//               <option value="hindi">Hindi</option>
//               <option value="telugu">Telugu</option>
//               <option value="tamil">Tamil</option>
//             </select>
//           </div>

//           <div style={filterGroupStyle}>
//             <label>Price</label>
//             <select value={price} onChange={(e) => setPrice(e.target.value)} style={dropdownStyle}>
//               <option value="">Price</option>
//               <option value="free">Free</option>
//               <option value="99">₹99</option>
//               <option value="500">₹500</option>
//             </select>
//           </div>
//         </div>

//         {/* Card Area */}
//         <div style={cardContainerStyle}>
//           <div style={cardGridStyle}>
//             {getCardsForSection().slice(0, 4).map((card, index) => (
//               <a key={index} href={card.link} style={cardStyle}>
//                 <img src={card.img} alt={card.title} style={imgStyle} />
//                 <h3>{card.title}</h3>
//               </a>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Styles
// const outerContainerStyle = {
//   border: '1px solid #ccc',
//   width: '100%',
//   height: 'calc(100vh - 60px)',
//   overflow: 'hidden',
//   position: 'relative',
//   fontFamily: 'sans-serif'
// };

// const topBarStyle = {
//   position: 'sticky',
//   top: 0,
//   background: '#fff',
//   padding: '10px 0',
//   display: 'flex',
//   justifyContent: 'center',
//   gap: '15px',
//   zIndex: 1000,
//   borderBottom: '1px solid #ddd'
// };

// const topBtnStyle = {
//   padding: '10px 20px',
//   background: '#0055aa',
//   color: '#fff',
//   border: 'none',
//   borderRadius: '5px',
//   cursor: 'pointer',
//   fontWeight: 'bold'
// };

// const mainContentStyle = {
//   display: 'flex',
//   height: '100%',
//   overflow: 'hidden'
// };

// const sidebarStyle = {
//   width: '280px',
//   background: '#f7f7f7',
//   padding: '20px',
//   overflowY: 'auto',
//   borderRight: '1px solid #ccc'
// };

// const filterGroupStyle = {
//   marginBottom: '20px'
// };

// const dropdownStyle = {
//   width: '100%',
//   padding: '8px',
//   borderRadius: '5px',
//   border: '1px solid #ccc'
// };

// const cardContainerStyle = {
//   flex: 1,
//   padding: '20px',
//   overflowY: 'auto'
// };

// const cardGridStyle = {
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '20px'
// };

// const cardStyle = {
//   background: '#fff',
//   padding: '15px',
//   borderRadius: '10px',
//   boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
//   textAlign: 'center',
//   textDecoration: 'none',
//   color: '#333',
//   height:'335px',
//   width:'335px'
// };

// const imgStyle = {
//   width: '100%',
//   height: '150px',
//   objectFit: 'cover',
//   borderRadius: '8px',
//   marginBottom: '10px'
// };

// export default MultiSectionFilter;




// import React, { useState } from 'react';
// import Coursesnew from './Coursesnew';

// const MainComponent = () => {
//   const [active, setActive] = useState('one');

//   const containerStyle = {
//     padding: '30px 20px',
//     textAlign: 'center',
//     fontFamily: 'sans-serif',
//   };

//   const buttonRowStyle = {
//     display: 'flex',
//     justifyContent: 'center',
//     flexWrap: 'wrap',
//     gap: '10px',
//     marginBottom: '25px',
//   };

//   const buttonStyle = (isActive) => ({
//     padding: '10px 20px',
//     border: 'none',
//     borderRadius: '5px',
//     backgroundColor: isActive ? '#007bff' : '#e0e0e0',
//     color: isActive ? '#fff' : '#000',
//     fontWeight: 'bold',
//     cursor: 'pointer',
//     transition: '0.3s',
//     minWidth: '100px',
//   });

//   const boxStyle = {

//     padding: '20px',

//     margin: '20px auto',
//     maxWidth: '1483px',
//     textAlign: 'left',
//     boxSizing: 'border-box',
//     marginTop:'-20px'
//   };

//   const activeBoxStyle = {
//     ...boxStyle,
//     // backgroundColor: '#e6f0ff',
//     borderColor: '#007bff',
//   };

//   const renderComponent = () => {
//     switch (active) {
//       case 'one':
//         return (
//           <div style={activeBoxStyle}>
//           <Coursesnew/>

//           </div>
//         );
//       case 'two':
//         return (
//           <div style={boxStyle}>
//             <h3>Filter 2</h3>
//             <p>This is the second filter content.</p>
//           </div>
//         );
//       case 'three':
//         return (
//           <div style={boxStyle}>
//             <h3>Filter 3</h3>
//             <p>This is the third filter content.</p>
//           </div>
//         );
//       case 'four':
//         return (
//           <div style={boxStyle}>
//             <h3>Filter 4</h3>
//             <p>This is the fourth filter content.</p>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <div style={containerStyle}>
//       <div style={buttonRowStyle}>
//         <button
//           style={buttonStyle(active === 'one')}
//           onClick={() => setActive('one')}
//         >
//           Button 1
//         </button>
//         <button
//           style={buttonStyle(active === 'two')}
//           onClick={() => setActive('two')}
//         >
//           Button 2
//         </button>
//         <button
//           style={buttonStyle(active === 'three')}
//           onClick={() => setActive('three')}
//         >
//           Button 3
//         </button>
//         <button
//           style={buttonStyle(active === 'four')}
//           onClick={() => setActive('four')}
//         >
//           Button 4
//         </button>
//       </div>

//       {/* Render only the active component */}
//       {renderComponent()}
//     </div>
//   );
// };

// export default MainComponent;




import React, { useState } from 'react';
import Tectaks from './Tectaks';
import Newprogram from './Newprogram';
import Jobdetals from './Jobdetals';
import Advertisment from './Advertisment';

const MainComponent = () => {
  const [active, setActive] = useState('one');

  const wrapperStyle = {
    maxHeight: '750px', // Set the scrollable area height as needed
    overflowY: 'auto',
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    border: '1px solid #ccc',
    borderRadius: '10px',
    padding: '0',
    position: 'relative',
  };


  const containerStyle = {
    // padding: '0px 20px 30px 20px',
    fontFamily: 'sans-serif',
  };

  const buttonRowStyle = {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '10px',
    padding: '20px',
    background: 'blue',
    position: 'sticky',
    top: 82,
    zIndex: 10,
    // borderBottom: '1px solid #ddd',
  };

  const buttonStyle = (isActive) => ({
    padding: '10px 20px',
    border: 'none',
    borderRadius: '30px',
    backgroundColor: isActive ? 'orange' : '#e0e0e0',
    color: isActive ? '#fff' : '#000',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: '0.3s',
    minWidth: '100px',
  });

  const boxStyle = {
    // padding: '63px',
    // margin: '20px auto',
    maxWidth: '1260px',
    textAlign: 'left',
    boxSizing: 'border-box',
    marginTop: '70px',
  };

  const activeBoxStyle = {
    ...boxStyle,
    borderColor: '#007bff',
  };








  const renderComponent = () => {



    switch (active) {
      case 'one':
        return (
          <div style={activeBoxStyle}>
            <div style={{ backgroundColor: 'blue' }}>
              <Tectaks />
            </div>
          </div>
        );
      case 'two':
        return (
          <div style={boxStyle}>

            <Newprogram />
          </div>
        );
      // case 'three':
      //   return (
      //     <div style={boxStyle}>
      //       <Jobdetals/>
      //     </div>
      //   );
      // case 'four':
      //   return (
      //     <div style={boxStyle}>
      //       <h3>Filter 4</h3>
      //       <p>This is the fourth filter content.</p>
      //     </div>
      //   );
      default:
        return null;
    }
  };

  return (
    <div className='tectalks-contner' style={wrapperStyle}>
      <div style={containerStyle}>
        <div className='buttonrowstyle' style={buttonRowStyle}>
          <button
            style={buttonStyle(active === 'one')}
            onClick={() => setActive('one')}
          >
            TecTalks
          </button>
          <button
            style={buttonStyle(active === 'two')}
            onClick={() => setActive('two')}
          >
            programs
          </button>
          {/* <button
            style={buttonStyle(active === 'three')}
            onClick={() => setActive('three')}
          >
            Jobs
          </button> */}
          {/* <button
            style={buttonStyle(active === 'four')}
            onClick={() => setActive('four')}
          >
            WalkingDrive
          </button> */}
        </div>
        
        {/* Scrollable content */}
        {renderComponent()}

        {/* <Advertisment /> */}
      </div>

    </div>
  );
};

export default MainComponent;



// import React, { useState } from 'react';
// import Tectaks from './Tectaks';
// import Newprogram from './Newprogram';
// import MainBanner from './MainBanner';

// const MainComponent = () => {
//   const [active, setActive] = useState('one');

//   const wrapperStyle = {
//     maxHeight: '700px',
//     overflowY: 'auto',
//     border: '1px solid #ccc',
//     borderRadius: '10px',
//     padding: '0',
//     position: 'relative',
//   };

//   const containerStyle = {
//     padding: '0px 20px 30px 20px',
//     fontFamily: 'sans-serif',
//   };

//   const buttonRowStyle = {
//     display: 'flex',
//     justifyContent: 'center',
//     flexWrap: 'wrap',
//     gap: '10px',
//     padding: '20px',
//     background: '#fff',
//     position: 'sticky',
//     top: 12,
//     zIndex: 10,
//   };

//   const buttonStyle = (isActive) => ({
//     padding: '10px 20px',
//     border: 'none',
//     borderRadius: '30px',
//     backgroundColor: isActive ? 'rgb(0 0 255)' : '#e0e0e0',
//     color: isActive ? '#fff' : '#000',
//     fontWeight: 'bold',
//     cursor: 'pointer',
//     transition: '0.3s',
//     minWidth: '100px',
//   });

//   const boxStyle = {
//     padding: '20px',
//     margin: '20px auto',
//     maxWidth: '1483px',
//     textAlign: 'left',
//     boxSizing: 'border-box',
//     marginTop: '-20px',
//   };

//   const activeBoxStyle = {
//     ...boxStyle,
//     borderColor: '#007bff',
//   };

//   const renderComponent = () => {
//     switch (active) {
//       case 'one':
//         return (
//           <div style={activeBoxStyle}>
//             <MainBanner />
//           </div>
//         );
//       case 'two':
//         return (
//           <div style={boxStyle}>
//             <Tectaks />
//           </div>
//         );
//       case 'three':
//         return (
//           <div style={boxStyle}>
//             <Newprogram />
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <div style={wrapperStyle}>
//       <div style={containerStyle}>
//         <div style={buttonRowStyle}>
//           <button
//             style={buttonStyle(active === 'two')}
//             onClick={() => setActive('two')}
//           >
//             TecTalks
//           </button>
//           <button
//             style={buttonStyle(active === 'three')}
//             onClick={() => setActive('three')}
//           >
//             Programs
//           </button>
//           {/* <button
//             style={buttonStyle(active === 'three')}
//             onClick={() => setActive('three')}
//           >
//             Jobs
//           </button> */}
//         </div>

//         {renderComponent()}
//       </div>
//     </div>
//   );
// };

// export default MainComponent;


